import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'

const NotAvailableContainer = styled('div')`
  padding: 30px 0;
  width: 100%;
`

const Message = styled('div')`
  background: #f0f6fa;
  padding: 20px;
  font-size: 20px;
  font-weight: 700;
  line-height: 123.5%;
  letter-spacing: 0.025rem;
  font-family: Roboto;
  color: #181818;

  ${mq.medium`
    font-size: 34px;
  `}
`

export default function NotAvailable({ domain, text }) {
  const { t } = useTranslation()

  return (
    <NotAvailableContainer>
      <Message>{text}</Message>
    </NotAvailableContainer>
  )
}
